/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of Servos::Application.
 * @version af99fafce3236c312c98e852e2a09313e6352fe9e4049bdf9e890ed1cfb2fdb3
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /accommodations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/addon_assignments/:id(.:format)
 * @param {any} accommodationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationAddonAssignmentUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/addon_assignments/:id(.:format)
 * @param {any} accommodationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationAddonAssignmentPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/addon_assignments(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationAddonAssignmentsUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/addon_assignments(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationAddonAssignmentsPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/email(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationEmailUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/email(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationEmailPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms/:id(.:format)
 * @param {any} accommodationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationRoomUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms/:id(.:format)
 * @param {any} accommodationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationRoomPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationRoomsUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationRoomsPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /accommodations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /accommodations/availabilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilitiesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availabilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilitiesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityRestrictionUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityRestrictionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityRestrictionsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsAvailabilityRestrictionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/housekeeping/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsHousekeepingUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/housekeeping/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsHousekeepingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsHousekeepingsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsHousekeepingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRuleUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRulePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing_rule_conflict_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRuleConflictCheckUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing_rule_conflict_check"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing_rule_conflict_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRuleConflictCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing_rule_conflict_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRulesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsPricingRulesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsRoomBlockUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsRoomBlockPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/blocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsRoomBlocksUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/blocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsRoomBlocksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/stays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsStaysUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/stays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accommodationsStaysPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bug_reports/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBugReportUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bug_reports"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/bug_reports/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBugReportPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bug_reports"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bug_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBugReportsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bug_reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/bug_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBugReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bug_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/checks/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCheckUrl = /*#__PURE__*/ __route({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/checks/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCheckPath = /*#__PURE__*/ __route({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChecksUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChecksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp/oauth/authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthAuthorizationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mcp/oauth/authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthAuthorizationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp/oauth/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthClientsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mcp/oauth/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthClientsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp/oauth/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthTokensUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mcp/oauth/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpOauthTokensPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alertsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alertsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appRootUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"app"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"app"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/attachment_order(.:format)
 * @param {any} attachableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableAttachmentOrderUrl = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"attachment_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/attachment_order(.:format)
 * @param {any} attachableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableAttachmentOrderPath = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"attachment_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/medias/:id(.:format)
 * @param {any} attachableGid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableMediaUrl = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"medias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/medias/:id(.:format)
 * @param {any} attachableGid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableMediaPath = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"medias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/medias(.:format)
 * @param {any} attachableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableMediasUrl = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"medias"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /attachables/:attachable_gid/medias(.:format)
 * @param {any} attachableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachableMediasPath = /*#__PURE__*/ __route({"attachable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachables"],[2,[7,"/"],[2,[3,"attachable_gid"],[2,[7,"/"],[2,[6,"medias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/e/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLegacyEventUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"e"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/e/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLegacyEventPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"e"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/s/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLegacyServiceUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/s/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLegacyServicePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/accommodations/availabilities(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationAccommodationsAvailabilitiesUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/accommodations/availabilities(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationAccommodationsAvailabilitiesPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/accommodations/bookable-dates(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationAccommodationsBookableDatesUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"bookable-dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/accommodations/bookable-dates(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationAccommodationsBookableDatesPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"bookable-dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart/items/:public_id(.:format)
 * @param {any} locationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartItemUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart/items/:public_id(.:format)
 * @param {any} locationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartItemPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart/items(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartItemsUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/cart/items(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationCartItemsPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/services/availabilities(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationServicesAvailabilitiesUrl = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/locations/:location_public_id/services/availabilities(.:format)
 * @param {any} locationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookLocationServicesAvailabilitiesPath = /*#__PURE__*/ __route({"location_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_public_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /book/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/stays/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationAccommodationUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/stays/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationAccommodationPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/stays(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationAccommodationsUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/stays(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationAccommodationsPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/events/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationEventUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/events/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationEventPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/events(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationEventsUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/events(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationEventsPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/llms.txt
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationLlmsUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"llms"],[2,[8,"."],[6,"txt"]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/llms.txt
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationLlmsPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"llms"],[2,[8,"."],[6,"txt"]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackageUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackagePath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages/:package_public_id/selections(.:format)
 * @param {any} organizationPublicId
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackageSelectionsUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages/:package_public_id/selections(.:format)
 * @param {any} organizationPublicId
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackageSelectionsPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackagesUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/packages(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPackagesPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/passes/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPassUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/passes/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPassPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/passes(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPassesUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/passes(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationPassesPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/experiences/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationServiceUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/experiences/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationServicePath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"experiences"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/experiences(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationServicesUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"experiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/experiences(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationServicesPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"experiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /book/:organization_public_id/sitemap.xml
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationSitemapUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]]]]]], true);

/**
 * Generates rails route to
 * /book/:organization_public_id/sitemap.xml
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookOrganizationSitemapPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]]]]]]);

/**
 * Generates rails route to
 * /book/sitemap.xml
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookSitemapIndexUrl = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]]]], true);

/**
 * Generates rails route to
 * /book/sitemap.xml
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookSitemapIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]]]]);

/**
 * Generates rails route to
 * /bookings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bookings/:booking_id/attendance(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingAttendanceUrl = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:booking_id/attendance(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingAttendancePath = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/:booking_id/cancellation(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingCancellationUrl = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:booking_id/cancellation(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingCancellationPath = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/:booking_id/reschedule(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingRescheduleUrl = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:booking_id/reschedule(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingReschedulePath = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/:booking_id/transfer(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingTransferUrl = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:booking_id/transfer(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingTransferPath = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /bookings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bug_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bugReportsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bug_reports"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /bug_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bugReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bug_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications/bulk_reading(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkReadingUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"bulk_reading"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /notifications/bulk_reading(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkReadingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"bulk_reading"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /for/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessTypeUrl = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"for"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /for/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessTypePath = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"for"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseStudyUrl = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caseStudyPath = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /changelog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changelogUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"changelog"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /changelog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changelogPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"changelog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/acknowledge(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionAcknowledgeUrl = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"acknowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/acknowledge(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionAcknowledgePath = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"acknowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/reprocess(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionReprocessUrl = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/reprocess(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionReprocessPath = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/retry(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionRetryUrl = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions/:booking_revision_id/retry(.:format)
 * @param {any} bookingRevisionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionRetryPath = /*#__PURE__*/ __route({"booking_revision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[2,[7,"/"],[2,[3,"booking_revision_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/booking_revisions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerBookingRevisionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"booking_revisions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerRootUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerWebhookUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerWebhookPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channel_manager/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerWebhooksUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channel_manager/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelManagerWebhooksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channel_manager"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:public_id(.:format)
 * @param {any} organizationPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/code(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartCodeUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/code(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartCodePath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/confirmation(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartConfirmationUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/confirmation(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartConfirmationPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/expiration(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartExpirationUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"expiration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/expiration(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartExpirationPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"expiration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/marketing_consent(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartMarketingConsentUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"marketing_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/marketing_consent(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartMarketingConsentPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"marketing_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/promotion(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartPromotionUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/:organization_public_id/:cart_public_id/promotion(.:format)
 * @param {any} organizationPublicId
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkoutOrganizationCartPromotionPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commentsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:customer_public_id/marketing_consent(.:format)
 * @param {any} customerPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerMarketingConsentUrl = /*#__PURE__*/ __route({"customer_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_public_id"],[2,[7,"/"],[2,[6,"marketing_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/:customer_public_id/marketing_consent(.:format)
 * @param {any} customerPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerMarketingConsentPath = /*#__PURE__*/ __route({"customer_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_public_id"],[2,[7,"/"],[2,[6,"marketing_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dining/tables/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diningTableUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dining/tables/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diningTablePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dining/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diningTablesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dining/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diningTablesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discounts/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discountUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /discounts/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discountPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discountsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /docs/*path
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPageUrl = /*#__PURE__*/ __route({"path":{"r":true}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[5,[3,"path"]]]]], true);

/**
 * Generates rails route to
 * /docs/*path
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPagePath = /*#__PURE__*/ __route({"path":{"r":true}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[5,[3,"path"]]]]]);

/**
 * Generates rails route to
 * /accommodations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsAvailabilityRestrictionUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsAvailabilityRestrictionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsPricingRuleUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsPricingRulePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsRoomBlockUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccommodationsRoomBlockPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dining/tables/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDiningTableUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dining/tables/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDiningTablePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discounts/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDiscountUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /discounts/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDiscountPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEventUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEventPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/billing/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfileBillingUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /profile/billing/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfileBillingPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/marketing_preferences/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfileMarketingPreferencesUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"marketing_preferences"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /profile/marketing_preferences/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfileMarketingPreferencesPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"marketing_preferences"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/personal_info/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfilePersonalInfoUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /profile/personal_info/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestProfilePersonalInfoPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/:public_id/edit(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/:public_id/edit(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGuestStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordResetUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordResetPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editKnowledgePageUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editKnowledgePagePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOccurrenceUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOccurrencePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/billing/edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrderBillingUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/billing/edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrderBillingPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/admin/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsAdminApiKeyUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/admin/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsAdminApiKeyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/default/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyDefaultUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"default"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/default/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyDefaultPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"default"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/details/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyDetailsUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/details/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyDetailsPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/rules/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyRulesUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/rules/edit(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsCancellationPolicyRulesPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/receipt_printers/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsReceiptPrinterUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/receipt_printers/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsReceiptPrinterPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsSalesChannelUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsSalesChannelPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping/edit(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsSalesChannelMappingUrl = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping/edit(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsSalesChannelMappingPath = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTaxUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/default/edit(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTaxDefaultUrl = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"default"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/default/edit(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTaxDefaultPath = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"default"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTeamUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsTeamPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsUserUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationSettingsUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackageUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackagePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/:id/edit(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackageBlockUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/:id/edit(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackageBlockPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/:id/edit(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackageSeasonRangeUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/:id/edit(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPackageSeasonRangePath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /passes/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPassUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /passes/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPassPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPosCartUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPosCartPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/availability/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProductsAvailabilityRuleUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/availability/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProductsAvailabilityRulePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/:public_id/edit(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editRegistrationStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/:public_id/edit(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editRegistrationStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/schedules/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editReportScheduleUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/schedules/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editReportSchedulePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServicePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/:id/edit(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceOpeningHourUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/:id/edit(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceOpeningHourPath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/schedules/:id/edit(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceScheduleUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/schedules/:id/edit(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceSchedulePath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/pricing/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServicesPricingRuleUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/pricing/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServicesPricingRulePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/:id/edit(.:format)
 * @param {any} resourceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServicesResourceBlockUrl = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/:id/edit(.:format)
 * @param {any} resourceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServicesResourceBlockPath = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shareables/:shareable_gid/share_link/edit(.:format)
 * @param {any} shareableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editShareableShareLinkUrl = /*#__PURE__*/ __route({"shareable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shareables"],[2,[7,"/"],[2,[3,"shareable_gid"],[2,[7,"/"],[2,[6,"share_link"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /shareables/:shareable_gid/share_link/edit(.:format)
 * @param {any} shareableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editShareableShareLinkPath = /*#__PURE__*/ __route({"shareable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shareables"],[2,[7,"/"],[2,[3,"shareable_gid"],[2,[7,"/"],[2,[6,"share_link"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /housekeeping/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStaffHousekeepingUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /housekeeping/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStaffHousekeepingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/:public_id/edit(.:format)
 * @param {any} stayId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStayGuestUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/:public_id/edit(.:format)
 * @param {any} stayId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStayGuestPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaskUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaskPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/edit(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaskSuggestionUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/edit(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaskSuggestionPath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkflowUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:public_id/edit(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkflowPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /entitlement_redemptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const entitlementRedemptionUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entitlement_redemptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /entitlement_redemptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const entitlementRedemptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entitlement_redemptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_public_id/check_ins(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventCheckInsUrl = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"check_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_public_id/check_ins(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventCheckInsPath = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"check_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/email(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventEmailUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/email(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventEmailPath = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_public_id/sales(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventSalesStatsUrl = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_public_id/sales(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventSalesStatsPath = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/sales/:ticket_id/check_in(.:format)
 * @param {any} eventId
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketCheckInUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"check_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/sales/:ticket_id/check_in(.:format)
 * @param {any} eventId
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketCheckInPath = /*#__PURE__*/ __route({"event_id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"check_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/sales/:ticket_id/check_in/undo(.:format)
 * @param {any} eventId
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketCheckInUndoUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/sales/:ticket_id/check_in/undo(.:format)
 * @param {any} eventId
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketCheckInUndoPath = /*#__PURE__*/ __route({"event_id":{"r":true},"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_public_id/scanner(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketScannerUrl = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"scanner"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_public_id/scanner(.:format)
 * @param {any} eventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketScannerPath = /*#__PURE__*/ __route({"event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_public_id"],[2,[7,"/"],[2,[6,"scanner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketVariantUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketVariantPath = /*#__PURE__*/ __route({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketVariantsUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketVariantsPath = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/sales(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketsUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/sales(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTicketsPath = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /reports/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featuresUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featuresPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /founder-letter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const founderLetterUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"founder-letter"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /founder-letter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const founderLetterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"founder-letter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /guarantee_card_charges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guaranteeCardChargesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"guarantee_card_charges"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /guarantee_card_charges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guaranteeCardChargesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"guarantee_card_charges"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bookings/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestBookingUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestBookingPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guest_classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestClassificationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /guest_classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestClassificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestDashboardUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestDashboardPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrderUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrderPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_public_id/billing(.:format)
 * @param {any} orderPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrderBillingUrl = /*#__PURE__*/ __route({"order_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_public_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_public_id/billing(.:format)
 * @param {any} orderPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrderBillingPath = /*#__PURE__*/ __route({"order_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_public_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrdersUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrdersPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/previews/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrdersPreviewLinkUrl = /*#__PURE__*/ __route({"token":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/previews/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestOrdersPreviewLinkPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestPackageUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestPackagePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfileUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfilePath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfileBillingUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profile/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfileBillingPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/marketing_preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfileMarketingPreferencesUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"marketing_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profile/marketing_preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfileMarketingPreferencesPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"marketing_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/personal_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfilePersonalInfoUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profile/personal_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestProfilePersonalInfoPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /receipts/:receipt_public_id/download(.:format)
 * @param {any} receiptPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestReceiptDownloadUrl = /*#__PURE__*/ __route({"receipt_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"receipt_public_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /receipts/:receipt_public_id/download(.:format)
 * @param {any} receiptPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestReceiptDownloadPath = /*#__PURE__*/ __route({"receipt_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"receipt_public_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestRootUrl = /*#__PURE__*/ __route({"subdomain":{"d":"guest"}}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestRootPath = /*#__PURE__*/ __route({"subdomain":{"d":"guest"}}, [7,"/"]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSessionUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSessionPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session/otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSessionOneTimePasswordUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /session/otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSessionOneTimePasswordPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signin/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSignInLinkUrl = /*#__PURE__*/ __route({"token":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"signin"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /signin/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestSignInLinkPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"signin"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/:public_id(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/:public_id(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guest_classifications(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestClassificationsUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guest_classifications(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestClassificationsPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestsUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestStayGuestsPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestTicketUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tickets/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guestTicketPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help/chats/:chat_id/messages(.:format)
 * @param {any} chatId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpChatMessagesUrl = /*#__PURE__*/ __route({"chat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /help/chats/:chat_id/messages(.:format)
 * @param {any} chatId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpChatMessagesPath = /*#__PURE__*/ __route({"chat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /help/chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpChatsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /help/chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpChatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityEmailVerificationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /identity/email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityEmailVerificationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordResetUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordResetPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitations/:invitation_id/resend(.:format)
 * @param {any} invitationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationResendUrl = /*#__PURE__*/ __route({"invitation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"invitation_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /invitations/:invitation_id/resend(.:format)
 * @param {any} invitationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationResendPath = /*#__PURE__*/ __route({"invitation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"invitation_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /knowledge/assets/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeAssetUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/assets/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeAssetPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/imports/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeImportsPagesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/imports/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeImportsPagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePagePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/assets(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageAssetsUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/assets(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageAssetsPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/content(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageContentUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/content(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageContentPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/position(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePagePositionUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/position(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePagePositionPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions/:public_id(.:format)
 * @param {any} pagePublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions/:public_id(.:format)
 * @param {any} pagePublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions/:version_public_id/restoration(.:format)
 * @param {any} pagePublicId
 * @param {any} versionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionRestorationUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"version_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"version_public_id"],[2,[7,"/"],[2,[6,"restoration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions/:version_public_id/restoration(.:format)
 * @param {any} pagePublicId
 * @param {any} versionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionRestorationPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"version_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"version_public_id"],[2,[7,"/"],[2,[6,"restoration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionsUrl = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages/:page_public_id/versions(.:format)
 * @param {any} pagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePageVersionsPath = /*#__PURE__*/ __route({"page_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_public_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePagesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgePagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeUploadsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/uploads/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeUploadsPresignUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/uploads/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeUploadsPresignPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leadsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe/:marketing_consent_token(.:format)
 * @param {any} marketingConsentToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingConsentWithdrawalUrl = /*#__PURE__*/ __route({"marketing_consent_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"marketing_consent_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /unsubscribe/:marketing_consent_token(.:format)
 * @param {any} marketingConsentToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingConsentWithdrawalPath = /*#__PURE__*/ __route({"marketing_consent_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"marketing_consent_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mcp/oauth/authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthAuthorizationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mcp/oauth/authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthAuthorizationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp/oauth/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthClientsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mcp/oauth/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthClientsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp/oauth/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthTokensUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mcp/oauth/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpOauthTokensPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /messages/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/messages/:message_id/delivery(.:format)
 * @param {any} conversationId
 * @param {any} messageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationMessageDeliveryUrl = /*#__PURE__*/ __route({"conversation_id":{"r":true},"message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/messages/:message_id/delivery(.:format)
 * @param {any} conversationId
 * @param {any} messageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationMessageDeliveryPath = /*#__PURE__*/ __route({"conversation_id":{"r":true},"message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/messages(.:format)
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationMessagesUrl = /*#__PURE__*/ __route({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/messages(.:format)
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationMessagesPath = /*#__PURE__*/ __route({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/no_reply_needed(.:format)
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationNoReplyNeededUrl = /*#__PURE__*/ __route({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"no_reply_needed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /messages/conversations/:conversation_id/no_reply_needed(.:format)
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationNoReplyNeededPath = /*#__PURE__*/ __route({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"no_reply_needed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /messages/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingConversationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingSyncUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /messages/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagingSyncPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms/new(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationRoomUrl = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/:accommodation_id/rooms/new(.:format)
 * @param {any} accommodationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationRoomPath = /*#__PURE__*/ __route({"accommodation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[3,"accommodation_id"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsAvailabilityRestrictionUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/restrictions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsAvailabilityRestrictionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"restrictions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsPricingRuleUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/pricing/rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsPricingRulePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsRoomBlockUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accommodations/availability/blocks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccommodationsRoomBlockPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accommodations"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp/oauth/authorizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminMcpOauthAuthorizationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mcp/oauth/authorizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminMcpOauthAuthorizationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/:booking_id/reschedule/new(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBookingRescheduleUrl = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"reschedule"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/:booking_id/reschedule/new(.:format)
 * @param {any} bookingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBookingReschedulePath = /*#__PURE__*/ __route({"booking_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"booking_id"],[2,[7,"/"],[2,[6,"reschedule"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bug_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBugReportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bug_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bug_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBugReportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bug_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dining/tables/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDiningTableUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dining/tables/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDiningTablePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dining"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDiscountUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /discounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDiscountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEventUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEventPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEventTicketVariantUrl = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /events/:event_id/ticket_variants/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEventTicketVariantPath = /*#__PURE__*/ __route({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGuestSessionUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGuestSessionPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/new(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGuestStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_public_id/guests/new(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGuestStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{},"subdomain":{"d":"guest"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newIdentityPasswordResetUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /identity/password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newIdentityPasswordResetPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvitationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvitationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newKnowledgeImportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /knowledge/imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newKnowledgeImportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp/oauth/authorizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMcpOauthAuthorizationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mcp/oauth/authorizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMcpOauthAuthorizationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOnboardingUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /onboarding/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOnboardingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/cancellation/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderCancellationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"cancellation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/cancellation/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderCancellationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"cancellation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderExternalPaymentUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderExternalPaymentPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderPaymentRequestUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderPaymentRequestPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderRefundUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderRefundPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/terminal_charge/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderTerminalChargeUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/terminal_charge/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrderTerminalChargePath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/admin/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsAdminApiKeyUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/admin/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsAdminApiKeyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/rotation/new(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsApiKeyRotationUrl = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"rotation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/rotation/new(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsApiKeyRotationPath = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"rotation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsCancellationPolicyUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsCancellationPolicyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/migration/mews_imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsMigrationMewsImportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/migration/mews_imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsMigrationMewsImportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/receipt_printers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsReceiptPrinterUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/receipt_printers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsReceiptPrinterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsSalesChannelUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsSalesChannelPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping/new(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsSalesChannelMappingUrl = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping/new(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsSalesChannelMappingPath = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/storefront/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsStorefrontApiKeyUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/storefront/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsStorefrontApiKeyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsTaxUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsTaxPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsTeamUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationSettingsTeamPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackageUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /packages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackagePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/new(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackageBlockUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/new(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackageBlockPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/new(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackageSeasonRangeUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/new(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPackageSeasonRangePath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /passes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPassUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /passes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPassPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/passes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPassProductUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/passes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPassProductPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount/new(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPosCartDiscountUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount/new(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPosCartDiscountPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPosCustomerUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPosCustomerPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product-collections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductCollectionUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product-collections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductCollectionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/availability/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductsAvailabilityRuleUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/availability/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProductsAvailabilityRulePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/new(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRegistrationStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/new(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRegistrationStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSavedReportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSavedReportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/schedules/new(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSavedReportScheduleUrl = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/schedules/new(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSavedReportSchedulePath = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /services/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceOpeningHourUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceOpeningHourPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/sessions/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceSessionUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/sessions/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceSessionPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/variants/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceVariantUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/variants/new(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceVariantPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/pricing/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesPricingRuleUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/pricing/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesPricingRulePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesResourceUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesResourcePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/new(.:format)
 * @param {any} resourceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesResourceBlockUrl = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/new(.:format)
 * @param {any} resourceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServicesResourceBlockPath = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSessionUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStaffSessionUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sign-in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStaffSessionPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"sign-in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/cancellation/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCancellationUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"cancellation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/cancellation/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCancellationPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"cancellation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCheckinUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCheckinPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCheckoutUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayCheckoutPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayGuestUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayGuestPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/room_lock/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayRoomLockUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_lock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/room_lock/new(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStayRoomLockPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_lock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/modifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStaysModificationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"modifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/modifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStaysModificationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"modifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaskUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaskPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taskables/:taskable_gid/tasks/new(.:format)
 * @param {any} taskableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaskableTaskUrl = /*#__PURE__*/ __route({"taskable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taskables"],[2,[7,"/"],[2,[3,"taskable_gid"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taskables/:taskable_gid/tasks/new(.:format)
 * @param {any} taskableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaskableTaskPath = /*#__PURE__*/ __route({"taskable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taskables"],[2,[7,"/"],[2,[3,"taskable_gid"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:notification_id/reading(.:format)
 * @param {any} notificationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationReadingUrl = /*#__PURE__*/ __route({"notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"reading"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /notifications/:notification_id/reading(.:format)
 * @param {any} notificationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationReadingPath = /*#__PURE__*/ __route({"notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"reading"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrencePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/attendees(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceAttendeesUrl = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/attendees(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceAttendeesPath = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/cancellation(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceCancellationUrl = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/cancellation(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceCancellationPath = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/checkin(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceCheckinUrl = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/checkin(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceCheckinPath = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/staffing(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceStaffingUrl = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"staffing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar/:occurrence_id/staffing(.:format)
 * @param {any} occurrenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrenceStaffingPath = /*#__PURE__*/ __route({"occurrence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[3,"occurrence_id"],[2,[7,"/"],[2,[6,"staffing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bookings/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrencesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bookings/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occurrencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/billing(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderBillingUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/billing(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderBillingPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/cancellation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderCancellationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/cancellation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderCancellationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/bulk_cart_items(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditBulkCartItemsUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"bulk_cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/bulk_cart_items(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditBulkCartItemsPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"bulk_cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_discounts/:id(.:format)
 * @param {any} orderEditId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartDiscountUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_discounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_discounts/:id(.:format)
 * @param {any} orderEditId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartDiscountPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_discounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_discounts(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartDiscountsUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_discounts(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartDiscountsPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_items/:id(.:format)
 * @param {any} orderEditId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartItemUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_items/:id(.:format)
 * @param {any} orderEditId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartItemPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_items(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartItemsUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/cart_items(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditCartItemsPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"cart_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/confirmation(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditConfirmationUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/confirmation(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditConfirmationPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/discounts(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditDiscountsUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/discounts(.:format)
 * @param {any} orderEditId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditDiscountsPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/discount(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemDiscountUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/discount(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemDiscountPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/modification(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemModificationUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"modification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/modification(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemModificationPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"modification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/price_change(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemPriceChangeUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"price_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/price_change(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemPriceChangePath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"price_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/void(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemVoidUrl = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /order_edits/:order_edit_id/order_items/:order_item_id/void(.:format)
 * @param {any} orderEditId
 * @param {any} orderItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderEditOrderItemVoidPath = /*#__PURE__*/ __route({"order_edit_id":{"r":true},"order_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_edits"],[2,[7,"/"],[2,[3,"order_edit_id"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"order_item_id"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments/:id(.:format)
 * @param {any} orderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderExternalPaymentUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments/:id(.:format)
 * @param {any} orderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderExternalPaymentPath = /*#__PURE__*/ __route({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderExternalPaymentsUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/external_payments(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderExternalPaymentsPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"external_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/:id(.:format)
 * @param {any} orderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/:id(.:format)
 * @param {any} orderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestPath = /*#__PURE__*/ __route({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/:payment_request_id/resend(.:format)
 * @param {any} orderId
 * @param {any} paymentRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestResendUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"payment_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"payment_request_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests/:payment_request_id/resend(.:format)
 * @param {any} orderId
 * @param {any} paymentRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestResendPath = /*#__PURE__*/ __route({"order_id":{"r":true},"payment_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"payment_request_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestsUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/payment_requests(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPaymentRequestsPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payment_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/preview(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPreviewUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/preview(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPreviewPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/purchase_bundles(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPurchaseBundlesUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"purchase_bundles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/purchase_bundles(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderPurchaseBundlesPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"purchase_bundles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/receipt(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderReceiptUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/receipt(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderReceiptPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/:refund_id/cancellation(.:format)
 * @param {any} orderId
 * @param {any} refundId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundCancellationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"refund_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"refund_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/:refund_id/cancellation(.:format)
 * @param {any} orderId
 * @param {any} refundId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundCancellationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"refund_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"refund_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/:refund_id/retry(.:format)
 * @param {any} orderId
 * @param {any} refundId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundRetryUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"refund_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"refund_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/refunds/:refund_id/retry(.:format)
 * @param {any} orderId
 * @param {any} refundId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundRetryPath = /*#__PURE__*/ __route({"order_id":{"r":true},"refund_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"refund_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/refunds(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundsUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/refunds(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderRefundsPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"refunds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/resend_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendConfirmationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/resend_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendConfirmationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/resend_package_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendPackageConfirmationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_package_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/resend_package_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendPackageConfirmationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_package_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/resend_stay_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendStayConfirmationUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_stay_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/resend_stay_confirmation(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendStayConfirmationPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_stay_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/resend_tickets(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendTicketsUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/resend_tickets(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderResendTicketsPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"resend_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderSearchesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"order_searches"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /order_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderSearchesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"order_searches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/terminal_charge(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderTerminalChargeUrl = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:order_id/terminal_charge(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderTerminalChargePath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ordersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ordersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationRootUrl = /*#__PURE__*/ __route({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationRootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /orgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSelectionUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /orgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSelectionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/activity-log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsActivityLogUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity-log"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/activity-log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsActivityLogPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"activity-log"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/admin/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAdminApiKeyUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/admin/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAdminApiKeyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAdminApiKeysUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAdminApiKeysPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/ai-assistants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAiAssistantUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai-assistants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/ai-assistants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsAiAssistantPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai-assistants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/revocation(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeyRevocationUrl = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"revocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/revocation(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeyRevocationPath = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"revocation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/rotation(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeyRotationUrl = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"rotation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/:organization_settings_api_key_id/rotation(.:format)
 * @param {any} organizationSettingsApiKeyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeyRotationPath = /*#__PURE__*/ __route({"organization_settings_api_key_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"organization_settings_api_key_id"],[2,[7,"/"],[2,[6,"rotation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeysUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsApiKeysPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/booking-site(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsBookingSiteUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"booking-site"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/booking-site(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsBookingSitePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"booking-site"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsBrandingUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsBrandingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPoliciesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPoliciesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/default(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyDefaultUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/default(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyDefaultPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/details(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyDetailsUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/details(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyDetailsPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/rules(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyRulesUrl = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/policies/:organization_settings_cancellation_policy_public_id/rules(.:format)
 * @param {any} organizationSettingsCancellationPolicyPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsCancellationPolicyRulesPath = /*#__PURE__*/ __route({"organization_settings_cancellation_policy_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"organization_settings_cancellation_policy_public_id"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/external_payment_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsExternalPaymentMethodUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"external_payment_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/external_payment_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsExternalPaymentMethodPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"external_payment_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/external_payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsExternalPaymentMethodsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"external_payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/external_payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsExternalPaymentMethodsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"external_payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/general(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsGeneralUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/general(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsGeneralPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationUrl = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationPath = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/authorization(.:format)
 * @param {any} integrationProvider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationAuthorizationUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/authorization(.:format)
 * @param {any} integrationProvider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationAuthorizationPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:public_id(.:format)
 * @param {any} integrationProvider
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:public_id(.:format)
 * @param {any} integrationProvider
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events/:booking_event_public_id/check(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {any} bookingEventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventCheckUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"booking_event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[2,[7,"/"],[2,[3,"booking_event_public_id"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events/:booking_event_public_id/check(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {any} bookingEventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventCheckPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"booking_event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[2,[7,"/"],[2,[3,"booking_event_public_id"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events/:booking_event_public_id/resend(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {any} bookingEventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventResendUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"booking_event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[2,[7,"/"],[2,[3,"booking_event_public_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events/:booking_event_public_id/resend(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {any} bookingEventPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventResendPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"booking_event_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[2,[7,"/"],[2,[3,"booking_event_public_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventsUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/booking_events(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionBookingEventsPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"booking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/places(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionPlacesUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"places"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/places(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionPlacesPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"places"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/reauthorization(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionReauthorizationUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"reauthorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections/:connection_public_id/reauthorization(.:format)
 * @param {any} integrationProvider
 * @param {any} connectionPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionReauthorizationPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"connection_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_public_id"],[2,[7,"/"],[2,[6,"reauthorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections(.:format)
 * @param {any} integrationProvider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionsUrl = /*#__PURE__*/ __route({"integration_provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations/:integration_provider/connections(.:format)
 * @param {any} integrationProvider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationConnectionsPath = /*#__PURE__*/ __route({"integration_provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsIntegrationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsLogoUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsLogoPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/migration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/migration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/migration/mews_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationMewsImportUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/migration/mews_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationMewsImportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/migration/mews_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationMewsImportsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/migration/mews_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsMigrationMewsImportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"migration"],[2,[7,"/"],[2,[6,"mews_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/account_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsAccountLinkUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"account_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/account_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsAccountLinkPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"account_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/nets_merchant_number(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsNetsMerchantNumberUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"nets_merchant_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/nets_merchant_number(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsNetsMerchantNumberPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"nets_merchant_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/stripe_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsStripeAccountUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"stripe_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/stripe_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPaymentsStripeAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"stripe_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payouts/:payout_id(.:format)
 * @param {any} payoutId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPayoutUrl = /*#__PURE__*/ __route({"payout_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[3,"payout_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payouts/:payout_id(.:format)
 * @param {any} payoutId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPayoutPath = /*#__PURE__*/ __route({"payout_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[3,"payout_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPayoutsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsPayoutsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/receipt_printers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsReceiptPrinterUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/receipt_printers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsReceiptPrinterPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/receipt_printers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsReceiptPrintersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/receipt_printers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsReceiptPrintersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"receipt_printers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/room-assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsRoomAssignmentUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"room-assignment"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/room-assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsRoomAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"room-assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/activation(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelActivationUrl = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/activation(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelActivationPath = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelMappingUrl = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/:organization_settings_sales_channel_public_id/mapping(.:format)
 * @param {any} organizationSettingsSalesChannelPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelMappingPath = /*#__PURE__*/ __route({"organization_settings_sales_channel_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[3,"organization_settings_sales_channel_public_id"],[2,[7,"/"],[2,[6,"mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/sales_channels/property(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelsPropertyUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[6,"property"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/sales_channels/property(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsSalesChannelsPropertyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_channels"],[2,[7,"/"],[2,[6,"property"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/storefront/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsStorefrontApiKeyUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/storefront/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsStorefrontApiKeyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/api/storefront(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsStorefrontApiKeysUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/api/storefront(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsStorefrontApiKeysPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"storefront"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/activation(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxActivationUrl = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/activation(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxActivationPath = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/default(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxDefaultUrl = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes/:organization_settings_tax_id/default(.:format)
 * @param {any} organizationSettingsTaxId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxDefaultPath = /*#__PURE__*/ __route({"organization_settings_tax_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"organization_settings_tax_id"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTaxesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams/:organization_settings_team_public_id/members/:public_id(.:format)
 * @param {any} organizationSettingsTeamPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamMemberUrl = /*#__PURE__*/ __route({"organization_settings_team_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"organization_settings_team_public_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams/:organization_settings_team_public_id/members/:public_id(.:format)
 * @param {any} organizationSettingsTeamPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamMemberPath = /*#__PURE__*/ __route({"organization_settings_team_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"organization_settings_team_public_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams/:organization_settings_team_public_id/members(.:format)
 * @param {any} organizationSettingsTeamPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamMembersUrl = /*#__PURE__*/ __route({"organization_settings_team_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"organization_settings_team_public_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams/:organization_settings_team_public_id/members(.:format)
 * @param {any} organizationSettingsTeamPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamMembersPath = /*#__PURE__*/ __route({"organization_settings_team_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"organization_settings_team_public_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTeamsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/terminal_readers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTerminalReaderUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"terminal_readers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/terminal_readers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTerminalReaderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"terminal_readers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/terminal_readers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTerminalReadersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"terminal_readers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/terminal_readers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsTerminalReadersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"terminal_readers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsUsersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationSettingsUsersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /packages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packagePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/availability(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageAvailabilityUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/availability(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageAvailabilityPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/:id(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageBlockUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks/:id(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageBlockPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageBlocksUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/blocks(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageBlocksPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/component_list(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageComponentListUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"component_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/component_list(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageComponentListPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"component_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/components(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageComponentsUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/components(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageComponentsPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/email(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageEmailUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/email(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageEmailPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/restrictions(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageRestrictionsUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/restrictions(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageRestrictionsPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/sales_windows(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSalesWindowsUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"sales_windows"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/sales_windows(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSalesWindowsPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"sales_windows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/:id(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSeasonRangeUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/season/:id(.:format)
 * @param {any} packagePublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSeasonRangePath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /packages/:package_public_id/season(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSeasonRangesUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /packages/:package_public_id/season(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packageSeasonRangesPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packagesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passes/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /passes/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/passes/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passProductUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/passes/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passProductPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/passes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passProductsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/passes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passProductsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /passes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /passes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /payment_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentRequestUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /payment_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payment_requests/:payment_request_id/success(.:format)
 * @param {any} paymentRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentRequestSuccessUrl = /*#__PURE__*/ __route({"payment_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"payment_request_id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /payment_requests/:payment_request_id/success(.:format)
 * @param {any} paymentRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentRequestSuccessPath = /*#__PURE__*/ __route({"payment_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payment_requests"],[2,[7,"/"],[2,[3,"payment_request_id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payouts_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payoutsExportUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts_export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payouts_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payoutsExportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payouts_export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /platform/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const platformPageUrl = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /platform/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const platformPagePath = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/bulk_items(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartBulkItemsUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"bulk_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/bulk_items(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartBulkItemsPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"bulk_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/customer(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartCustomerUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"customer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/customer(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartCustomerPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"customer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartDiscountUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartDiscountPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount_applications(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartDiscountApplicationsUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/discount_applications(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartDiscountApplicationsPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"discount_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/items/:id(.:format)
 * @param {any} cartPublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartItemUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/items/:id(.:format)
 * @param {any} cartPublicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartItemPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/items(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartItemsUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/items(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartItemsPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/package_selections/:public_id(.:format)
 * @param {any} cartPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPackageSelectionUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"package_selections"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/package_selections/:public_id(.:format)
 * @param {any} cartPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPackageSelectionPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"package_selections"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/package_selections(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPackageSelectionsUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"package_selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/package_selections(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPackageSelectionsPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"package_selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/payment_link(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPaymentLinkUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"payment_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/payment_link(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPaymentLinkPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"payment_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/promotion(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPromotionUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/promotion(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartPromotionPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/selection(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartSelectionUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/selection(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartSelectionPath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/terminal_charge(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartTerminalChargeUrl = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts/:cart_public_id/terminal_charge(.:format)
 * @param {any} cartPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartTerminalChargePath = /*#__PURE__*/ __route({"cart_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"cart_public_id"],[2,[7,"/"],[2,[6,"terminal_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCartsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"carts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCheckoutUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCheckoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/customer_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCustomerSearchesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customer_searches"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/customer_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCustomerSearchesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customer_searches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCustomersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posCustomersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posDiscountsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posDiscountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/packages/:package_public_id/check_ins(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posPackageCheckInsUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"check_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/packages/:package_public_id/check_ins(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posPackageCheckInsPath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"check_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/packages/:package_public_id/quote(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posPackageQuoteUrl = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"quote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/packages/:package_public_id/quote(.:format)
 * @param {any} packagePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posPackageQuotePath = /*#__PURE__*/ __route({"package_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"package_public_id"],[2,[7,"/"],[2,[6,"quote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posRegisterUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posRegisterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pos/register/:tab(.:format)
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posRegisterTabUrl = /*#__PURE__*/ __route({"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/register/:tab(.:format)
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posRegisterTabPath = /*#__PURE__*/ __route({"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/tables/:table_id/selection(.:format)
 * @param {any} tableId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posTableSelectionUrl = /*#__PURE__*/ __route({"table_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"table_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pos/tables/:table_id/selection(.:format)
 * @param {any} tableId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posTableSelectionPath = /*#__PURE__*/ __route({"table_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"tables"],[2,[7,"/"],[2,[3,"table_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pos/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posTablesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pos/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posTablesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pos"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacyPolicyUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacyPolicyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product-collections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product-collections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product-collections/:product_collection_id/memberships/:id(.:format)
 * @param {any} productCollectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionMembershipUrl = /*#__PURE__*/ __route({"product_collection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"product_collection_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /product-collections/:product_collection_id/memberships/:id(.:format)
 * @param {any} productCollectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionMembershipPath = /*#__PURE__*/ __route({"product_collection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"product_collection_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /product-collections/:product_collection_id/memberships(.:format)
 * @param {any} productCollectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionMembershipsUrl = /*#__PURE__*/ __route({"product_collection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"product_collection_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /product-collections/:product_collection_id/memberships(.:format)
 * @param {any} productCollectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionMembershipsPath = /*#__PURE__*/ __route({"product_collection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[2,[7,"/"],[2,[3,"product_collection_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product-collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /product-collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCollectionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"product-collections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/options/:id(.:format)
 * @param {any} productId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/options/:id(.:format)
 * @param {any} productId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionPath = /*#__PURE__*/ __route({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/option_positions(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionPositionsUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"option_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/option_positions(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionPositionsPath = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"option_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/options(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionsUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/options(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productOptionsPath = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/variants/:id(.:format)
 * @param {any} productId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/variants/:id(.:format)
 * @param {any} productId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantPath = /*#__PURE__*/ __route({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/variant_pricing(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantPricingUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variant_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/variant_pricing(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantPricingPath = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variant_pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/variants(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantsUrl = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/variants(.:format)
 * @param {any} productId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productVariantsPath = /*#__PURE__*/ __route({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/availability/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsAvailabilityRuleUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/availability/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsAvailabilityRulePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsAvailabilityRulesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productsAvailabilityRulesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchasables/:purchasable_gid/order_preview(.:format)
 * @param {any} purchasableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchasableOrderPreviewUrl = /*#__PURE__*/ __route({"purchasable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchasables"],[2,[7,"/"],[2,[3,"purchasable_gid"],[2,[7,"/"],[2,[6,"order_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchasables/:purchasable_gid/order_preview(.:format)
 * @param {any} purchasableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchasableOrderPreviewPath = /*#__PURE__*/ __route({"purchasable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchasables"],[2,[7,"/"],[2,[3,"purchasable_gid"],[2,[7,"/"],[2,[6,"order_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaManifestUrl = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaManifestPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaServiceWorkerUrl = /*#__PURE__*/ __route({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaServiceWorkerPath = /*#__PURE__*/ __route({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registration/links/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationLinkUrl = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/links/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationLinkPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationLookupUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationLookupPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/:public_id(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests/:public_id(.:format)
 * @param {any} stayPublicId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guest_classifications(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestClassificationsUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guest_classifications(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestClassificationsPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guest_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestsUrl = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /registration/stays/:stay_public_id/guests(.:format)
 * @param {any} stayPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationStayGuestsPath = /*#__PURE__*/ __route({"stay_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_public_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/query-draft(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportQueryDraftUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"query-draft"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/query-draft(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportQueryDraftPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"query-draft"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/schedules/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportScheduleUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/schedules/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportSchedulePath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootUrl = /*#__PURE__*/ __route({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /custom-reports/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportUrl = /*#__PURE__*/ __route({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportPath = /*#__PURE__*/ __route({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/export(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportExportUrl = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/export(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportExportPath = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/schedules(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportSchedulesUrl = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /custom-reports/:saved_report_key/schedules(.:format)
 * @param {any} savedReportKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportSchedulesPath = /*#__PURE__*/ __route({"saved_report_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[2,[7,"/"],[2,[3,"saved_report_key"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /custom-reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /custom-reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savedReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"custom-reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/addon_assignments/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceAddonAssignmentUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/addon_assignments/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceAddonAssignmentPath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/addon_assignments(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceAddonAssignmentsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/addon_assignments(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceAddonAssignmentsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"addon_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/email(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceEmailUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/email(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceEmailPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceOpeningHourUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceOpeningHourPath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceOpeningHoursUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/opening_hours(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceOpeningHoursPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"opening_hours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/resource_requirements/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceResourceRequirementUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"resource_requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/resource_requirements/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceResourceRequirementPath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"resource_requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/resource_requirements(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceResourceRequirementsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"resource_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/resource_requirements(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceResourceRequirementsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"resource_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/schedules/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceScheduleUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/schedules/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSchedulePath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/schedules(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSchedulesUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/schedules(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSchedulesPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/sessions(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSessionsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/sessions(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSessionsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/slot_calendars(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSlotCalendarsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"slot_calendars"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/slot_calendars(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSlotCalendarsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"slot_calendars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/slots(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSlotsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/slots(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSlotsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/variants/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceVariantUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/variants/:id(.:format)
 * @param {any} serviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceVariantPath = /*#__PURE__*/ __route({"service_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/:service_id/variants(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceVariantsUrl = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/:service_id/variants(.:format)
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceVariantsPath = /*#__PURE__*/ __route({"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /services/pricing/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesPricingRuleUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/pricing/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesPricingRulePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesPricingRulesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /services/pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesPricingRulesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourceUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourcePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/:id(.:format)
 * @param {any} resourceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourceBlockUrl = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks/:id(.:format)
 * @param {any} resourceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourceBlockPath = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks(.:format)
 * @param {any} resourceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourceBlocksUrl = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources/:resource_id/blocks(.:format)
 * @param {any} resourceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourceBlocksPath = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourcesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /services/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const servicesResourcesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /share_links/:share_link_token/access(.:format)
 * @param {any} shareLinkToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareLinkAccessUrl = /*#__PURE__*/ __route({"share_link_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"share_links"],[2,[7,"/"],[2,[3,"share_link_token"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /share_links/:share_link_token/access(.:format)
 * @param {any} shareLinkToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareLinkAccessPath = /*#__PURE__*/ __route({"share_link_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"share_links"],[2,[7,"/"],[2,[3,"share_link_token"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shareables/:shareable_gid/share_links/:id(.:format)
 * @param {any} shareableGid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareableShareLinkUrl = /*#__PURE__*/ __route({"shareable_gid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shareables"],[2,[7,"/"],[2,[3,"shareable_gid"],[2,[7,"/"],[2,[6,"share_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /shareables/:shareable_gid/share_links/:id(.:format)
 * @param {any} shareableGid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareableShareLinkPath = /*#__PURE__*/ __route({"shareable_gid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shareables"],[2,[7,"/"],[2,[3,"shareable_gid"],[2,[7,"/"],[2,[6,"share_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap.xml
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapUrl = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]], true);

/**
 * Generates rails route to
 * /sitemap.xml
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[6,"xml"]]]]);

/**
 * Generates rails route to
 * /guests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffGuestActivitiesUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /guests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffGuestActivitiesPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /housekeeping/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffHousekeepingUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /housekeeping/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffHousekeepingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffHousekeepingsUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /housekeeping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffHousekeepingsPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_public_id/selection(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffOrganizationSelectionUrl = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_public_id/selection(.:format)
 * @param {any} organizationPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffOrganizationSelectionPath = /*#__PURE__*/ __route({"organization_public_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_public_id"],[2,[7,"/"],[2,[6,"selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffOrganizationsUrl = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffOrganizationsPath = /*#__PURE__*/ __route({"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffPwaManifestUrl = /*#__PURE__*/ __route({"format":{"d":"json"},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffPwaManifestPath = /*#__PURE__*/ __route({"format":{"d":"json"},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffPwaServiceWorkerUrl = /*#__PURE__*/ __route({"format":{"d":"js"},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffPwaServiceWorkerPath = /*#__PURE__*/ __route({"format":{"d":"js"},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffRootUrl = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffRootPath = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [7,"/"]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffSessionUrl = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffSessionPath = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [7,"/"]);

/**
 * Generates rails route to
 * /stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayCheckinUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayCheckinPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayCheckoutUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffStayCheckoutPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{},"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/apple-app-site-association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffWellKnownAppleAppSiteAssociationUrl = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[6,"apple-app-site-association"]]]]], true);

/**
 * Generates rails route to
 * /.well-known/apple-app-site-association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffWellKnownAppleAppSiteAssociationPath = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[6,"apple-app-site-association"]]]]]);

/**
 * Generates rails route to
 * /.well-known/assetlinks.json
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffWellKnownAssetLinksUrl = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"assetlinks"],[2,[8,"."],[6,"json"]]]]]]], true);

/**
 * Generates rails route to
 * /.well-known/assetlinks.json
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffWellKnownAssetLinksPath = /*#__PURE__*/ __route({"subdomain":{"d":"staff"}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"assetlinks"],[2,[8,"."],[6,"json"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/cancellation(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCancellationUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/cancellation(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCancellationPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckinUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckinPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin/undo(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckinUndoUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkin/undo(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckinUndoPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkin"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckoutUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/checkout(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayCheckoutPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/:public_id(.:format)
 * @param {any} stayId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayGuestUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/guests/:public_id(.:format)
 * @param {any} stayId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayGuestPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/guests(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayGuestsUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/guests(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayGuestsPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"guests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/pre_checkin_mailer(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayPreCheckinMailerUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"pre_checkin_mailer"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/pre_checkin_mailer(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayPreCheckinMailerPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"pre_checkin_mailer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/room_assignment(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayRoomAssignmentUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/room_assignment(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayRoomAssignmentPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays/:stay_id/room_lock(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayRoomLockUrl = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/:stay_id/room_lock(.:format)
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stayRoomLockPath = /*#__PURE__*/ __route({"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"room_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /stays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /stays/modifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysModificationsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"modifications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stays/modifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysModificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"modifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/timeline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysTimelineUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stays/timeline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysTimelinePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stays/timeline/stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysTimelineStayUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"timeline"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /stays/timeline/stays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staysTimelineStayPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"timeline"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectRootUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/stripe_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhookUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhookPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks/:webhook_id/reprocess(.:format)
 * @param {any} webhookId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhookReprocessUrl = /*#__PURE__*/ __route({"webhook_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"webhook_id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks/:webhook_id/reprocess(.:format)
 * @param {any} webhookId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhookReprocessPath = /*#__PURE__*/ __route({"webhook_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"webhook_id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhooksUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/stripe_connect/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhooksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/completion(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskCompletionUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/completion(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskCompletionPath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/restoration(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskRestorationUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"restoration"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/restoration(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskRestorationPath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"restoration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionPath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/acceptance(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionAcceptanceUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/acceptance(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionAcceptancePath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/decline(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionDeclineUrl = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /tasks/:task_public_id/suggestion/decline(.:format)
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskSuggestionDeclinePath = /*#__PURE__*/ __route({"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"suggestion"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taskables/:taskable_gid/tasks(.:format)
 * @param {any} taskableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskableTasksUrl = /*#__PURE__*/ __route({"taskable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taskables"],[2,[7,"/"],[2,[3,"taskable_gid"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taskables/:taskable_gid/tasks(.:format)
 * @param {any} taskableGid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taskableTasksPath = /*#__PURE__*/ __route({"taskable_gid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taskables"],[2,[7,"/"],[2,[3,"taskable_gid"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terminal/readers/:reader_id/action(.:format)
 * @param {any} readerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalReaderActionUrl = /*#__PURE__*/ __route({"reader_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"reader_id"],[2,[7,"/"],[2,[6,"action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /terminal/readers/:reader_id/action(.:format)
 * @param {any} readerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalReaderActionPath = /*#__PURE__*/ __route({"reader_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"reader_id"],[2,[7,"/"],[2,[6,"action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terminal/readers/:reader_id/card_presentations(.:format)
 * @param {any} readerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalReaderCardPresentationsUrl = /*#__PURE__*/ __route({"reader_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"reader_id"],[2,[7,"/"],[2,[6,"card_presentations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /terminal/readers/:reader_id/card_presentations(.:format)
 * @param {any} readerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalReaderCardPresentationsPath = /*#__PURE__*/ __route({"reader_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"reader_id"],[2,[7,"/"],[2,[6,"card_presentations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terminal/simulator/readers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalSimulatorReaderUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"simulator"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /terminal/simulator/readers/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalSimulatorReaderPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"simulator"],[2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terminal/simulator/readers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalSimulatorReadersUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"simulator"],[2,[7,"/"],[2,[6,"readers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /terminal/simulator/readers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalSimulatorReadersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terminal"],[2,[7,"/"],[2,[6,"simulator"],[2,[7,"/"],[2,[6,"readers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sales/:ticket_id/cancellation(.:format)
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketCancellationUrl = /*#__PURE__*/ __route({"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /sales/:ticket_id/cancellation(.:format)
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketCancellationPath = /*#__PURE__*/ __route({"ticket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /o/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketsOrderUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"tickets"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /o/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketsOrderPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"tickets"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /t/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketsTicketUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"tickets"}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /t/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticketsTicketPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{},"subdomain":{"d":"tickets"}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUrl = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/activation(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userActivationUrl = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/:user_id/activation(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userActivationPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/password_reset(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordResetUrl = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/:user_id/password_reset(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordResetPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vcc_charges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vccChargesUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"vcc_charges"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /vcc_charges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vccChargesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"vcc_charges"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/whatsapp/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsappSignupUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"whatsapp"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/whatsapp/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsappSignupPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"whatsapp"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /whatsapp/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsappWebhookUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"whatsapp"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /whatsapp/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsappWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"whatsapp"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowUrl = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/email_draft(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowEmailDraftUrl = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"email_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/email_draft(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowEmailDraftPath = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"email_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/publication(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowPublicationUrl = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/publication(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowPublicationPath = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/resumption(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowResumptionUrl = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"resumption"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:workflow_public_id/resumption(.:format)
 * @param {any} workflowPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowResumptionPath = /*#__PURE__*/ __route({"workflow_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_public_id"],[2,[7,"/"],[2,[6,"resumption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowsUrl = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflowsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]]);

